import { isGbPricingPlan } from "helpers/pricingPlan";
import { type AnalyticsManager } from "services/analytics/analyticsManager";
import { type CompanyStore } from "services/company/companyStore";
import { type CompanyProductsStore } from "services/companyProducts/companyProductsStore";
import { type PricingPlanClient } from "services/pricingPlan/pricingPlanClient";
import { PricingPlanStoreBase } from "services/pricingPlan/pricingPlanStoreBase";
import { PricingPlan, type PricingPlanGb } from "services/pricingPlan/pricingPlanTypes";

export class PricingPlanStore extends PricingPlanStoreBase<PricingPlanGb> {
  constructor(
    protected readonly _companyStore: CompanyStore,
    protected readonly _companyProductsStore: CompanyProductsStore,
    protected readonly _pricingPlanClient: PricingPlanClient,
    protected readonly _analyticsManager: AnalyticsManager,
  ) {
    super(_companyStore, _companyProductsStore, _pricingPlanClient, _analyticsManager);
  }

  isSupportedPricingPlan(pricingPlan: PricingPlan): pricingPlan is PricingPlanGb {
    return isGbPricingPlan(pricingPlan);
  }

  async resetPricingPlan(): Promise<void> {
    await this._companyStore.updatePricingPlan(null);
  }
}
